import { render, staticRenderFns } from "./Administrator.vue?vue&type=template&id=40c7f33f&scoped=true&"
import script from "@/views/Users/Administrator/Administrator.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Administrator/Administrator.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Administrator/administrator.scss?vue&type=style&index=0&id=40c7f33f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c7f33f",
  null
  
)

export default component.exports